import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const GeneralSurgeryIcon = React.memo(({ width = 81, height = 80, viewBox = '0 0 81 80' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={remCss(width)}
    height={remCss(height)}
    viewBox={viewBox}
  >
    <path
      d='M79.5 40C79.5 61.8153 61.8153 79.5 40 79.5C18.1848 79.5 0.5 61.8153 0.5 40C0.5 18.1848 18.1848 0.5 40 0.5C61.8153 0.5 79.5 18.1848 79.5 40Z'
      fill={variables['colors-mc-primary']}
      fillOpacity='0.1'
      stroke={variables['colors-mc-primary']}
    />
    <g clipPath='url(#clip0_414_10863)'>
      <path
        d='M21.2402 53.4089V64.2377C21.2402 64.6154 21.5462 64.9213 21.9234 64.9213H23.3475C23.7247 64.9213 24.0307 64.6154 24.0307 64.2377V53.4089H21.2402Z'
        fill='#AA493F'
      />
      <path
        d='M55.9692 53.4089V64.2377C55.9692 64.6154 56.2752 64.9213 56.6525 64.9213H58.0765C58.4538 64.9213 58.7597 64.6154 58.7597 64.2377V53.4089H55.9692Z'
        fill='#AA493F'
      />
      <path
        d='M23.1331 64.2377V53.4089H21.2402V64.2377C21.2402 64.6154 21.5462 64.9213 21.9234 64.9213H23.3475C23.4299 64.9213 23.5088 64.9057 23.5821 64.879C23.3204 64.7832 23.1331 64.5326 23.1331 64.2377Z'
        fill='#993B36'
      />
      <path
        d='M57.8621 64.2377V53.4089H55.9692V64.2377C55.9692 64.6154 56.2752 64.9213 56.6525 64.9213H58.0765C58.1589 64.9213 58.2378 64.9057 58.3111 64.879C58.0494 64.7832 57.8621 64.5326 57.8621 64.2377Z'
        fill='#993B36'
      />
      <path
        d='M64.1216 15H56.7059C56.4156 15 56.1821 15.0805 56.0131 15.322L52.6291 20.1544C52.3903 20.4958 52.4731 20.9666 52.8145 21.2054C52.9461 21.2977 53.0971 21.3419 53.2467 21.3419C53.4843 21.3419 53.7186 21.2298 53.8654 21.02L57.024 16.5091H64.1216C64.5382 16.5091 64.8762 16.1711 64.8762 15.7545C64.8762 15.3376 64.5386 15 64.1216 15Z'
        fill='#DDE4F7'
      />
      <path
        d='M41.9722 19.4651C41.4286 20.7079 41.7681 22.1632 42.8599 22.9273C43.9516 23.6918 45.4352 23.5132 46.4171 22.5775L41.9722 19.4651Z'
        fill='#FEC13B'
      />
      <path
        d='M47.7437 23.5063C47.2001 24.7492 47.5396 26.2045 48.6314 26.9689C49.7227 27.733 51.2067 27.5545 52.1886 26.6188L47.7437 23.5063Z'
        fill='#FEC13B'
      />
      <path
        d='M53.5157 27.5476C52.9721 28.7904 53.3116 30.2457 54.4033 31.0102C55.4947 31.7743 56.9786 31.5958 57.9605 30.66L53.5157 27.5476Z'
        fill='#FEC13B'
      />
      <path
        d='M45.0034 22.9273C44.2885 22.4268 43.8986 21.6299 43.8654 20.7907L41.9722 19.4651C41.4286 20.7079 41.7681 22.1632 42.8599 22.9273C43.6396 23.4732 44.6184 23.5358 45.4726 23.1875C45.3104 23.1177 45.1529 23.0322 45.0034 22.9273Z'
        fill='#F9A332'
      />
      <path
        d='M50.7748 26.9689C50.06 26.4685 49.6701 25.6712 49.6369 24.832L47.7437 23.5063C47.2001 24.7492 47.5396 26.2045 48.6314 26.9689C49.4111 27.5148 50.3899 27.5774 51.244 27.2287C51.0819 27.1589 50.9244 27.0735 50.7748 26.9689Z'
        fill='#F9A332'
      />
      <path
        d='M56.5466 31.0102C55.8318 30.5097 55.4419 29.7124 55.4087 28.8732L53.5155 27.5476C52.9723 28.7904 53.3114 30.2457 54.4032 31.0102C55.1829 31.5561 56.1617 31.6187 57.0158 31.27C56.8537 31.2002 56.6962 31.1147 56.5466 31.0102Z'
        fill='#F9A332'
      />
      <path
        d='M63.6237 46.9932H16.3763C15.6191 46.9932 15 47.6123 15 48.3691V49.7455C15 50.5023 15.6191 51.1218 16.3763 51.1218H63.6237C64.3805 51.1218 65 50.5023 65 49.7455V48.3691C65 47.6123 64.3809 46.9932 63.6237 46.9932Z'
        fill='#B9E1FB'
      />
      <path
        d='M18.5213 49.7455V48.3691C18.5213 47.6123 19.1405 46.9932 19.8977 46.9932H16.3763C15.6191 46.9932 15 47.6123 15 48.3691V49.7455C15 50.5023 15.6191 51.1218 16.3763 51.1218H19.8973C19.1405 51.1218 18.5213 50.5023 18.5213 49.7455Z'
        fill='#9AD3F6'
      />
      <path
        d='M28.9908 45.6171V44.2407C28.9908 43.4839 28.3717 42.8647 27.6148 42.8647H16.3763C15.6191 42.8647 15 43.4839 15 44.2407V45.6171C15 46.3739 15.6191 46.993 16.3763 46.993H27.6148C28.3717 46.993 28.9908 46.3739 28.9908 45.6171Z'
        fill='#9AD3F6'
      />
      <path
        d='M18.5213 45.6171V44.2407C18.5213 43.4839 19.1405 42.8647 19.8977 42.8647H16.3763C15.6191 42.8647 15 43.4839 15 44.2407V45.6171C15 46.3739 15.6191 46.993 16.3763 46.993H19.8973C19.1405 46.993 18.5213 46.3739 18.5213 45.6171Z'
        fill='#78CBF4'
      />
      <path
        d='M17.0259 51.1218V52.5359C17.0259 53.2928 17.645 53.9123 18.4022 53.9123H61.5976C62.3544 53.9123 62.9739 53.2928 62.9739 52.5359V51.1218H17.0259Z'
        fill='#B7594A'
      />
      <path
        d='M20.5472 52.5359V51.1218H17.0259V52.5359C17.0259 53.2928 17.645 53.9123 18.4022 53.9123H21.9236C21.1664 53.9123 20.5472 53.2928 20.5472 52.5359Z'
        fill='#AA493F'
      />
      <path
        d='M59.984 27.8696C59.9108 25.8055 58.972 23.8581 57.25 22.6523L49.6721 17.3464C47.9498 16.1406 45.799 15.9243 43.8345 16.5613L59.984 27.8696Z'
        fill='#CCD7F2'
      />
      <path
        d='M48.0436 17.4478C47.6995 17.2071 47.6862 16.7665 47.9032 16.4873C46.5894 16.0898 45.1692 16.1283 43.8345 16.5613L59.9844 27.8692C59.9542 27.0277 59.778 26.2064 59.466 25.4457L48.0436 17.4478Z'
        fill='#BCCCED'
      />
      <path
        d='M44.738 32.5296C44.3966 32.2905 44.3134 31.8201 44.5526 31.4787L46.1578 29.1861C46.397 28.8446 46.8673 28.7619 47.2088 29.0007C47.5502 29.2398 47.633 29.7106 47.3938 30.0516L45.7886 32.3442C45.5498 32.6857 45.0794 32.7688 44.738 32.5296Z'
        fill='#FCDFAE'
      />
      <path
        d='M48.6674 34.3241C48.2584 34.2429 47.9929 33.8458 48.0742 33.4369L48.6189 30.6918C48.7002 30.2829 49.0969 30.0174 49.5059 30.0986C49.9148 30.1799 50.1803 30.577 50.099 30.9855L49.5543 33.7306C49.4734 34.1391 49.0767 34.405 48.6674 34.3241Z'
        fill='#FCDFAE'
      />
      <path
        d='M41.7077 29.4505C41.4914 29.0942 41.6054 28.6304 41.9617 28.4141L44.3551 26.9633C44.7114 26.7474 45.1752 26.8611 45.3915 27.2178C45.6074 27.5741 45.4938 28.0379 45.1371 28.2542L42.7441 29.705C42.3878 29.9205 41.9236 29.8072 41.7077 29.4505Z'
        fill='#FCDFAE'
      />
      <path
        d='M35.0573 35.448H17.2224C15.9972 35.448 15 34.4508 15 33.2255V21.427C15 20.2014 15.9972 19.2046 17.2224 19.2046H35.0573C36.283 19.2046 37.2797 20.2014 37.2797 21.427V33.2255C37.2797 34.4508 36.283 35.448 35.0573 35.448Z'
        fill='#DDE4F7'
      />
      <path
        d='M18.5213 33.2255V21.427C18.5213 20.2014 19.5185 19.2046 20.7438 19.2046H17.2224C15.9972 19.2042 15 20.2014 15 21.427V33.2255C15 34.4508 15.9972 35.448 17.2224 35.448H20.7438C19.5185 35.448 18.5213 34.4508 18.5213 33.2255Z'
        fill='#CCD7F2'
      />
      <path
        d='M34.2454 21.948H18.0352C17.8746 21.948 17.7441 22.0785 17.7441 22.2391V32.4129C17.7441 32.5735 17.8746 32.7039 18.0352 32.7039H34.2454C34.406 32.7039 34.5364 32.5735 34.5364 32.4129V22.2391C34.5364 22.0785 34.406 21.948 34.2454 21.948Z'
        fill='#63A1FC'
      />
      <path
        d='M21.2655 32.4129V22.2391C21.2655 22.0785 21.3956 21.948 21.5565 21.948H18.0352C17.8746 21.948 17.7441 22.0785 17.7441 22.2391V32.4129C17.7441 32.5735 17.8746 32.7039 18.0352 32.7039H21.5565C21.3956 32.7039 21.2655 32.5735 21.2655 32.4129Z'
        fill='#4188FF'
      />
      <path
        d='M23.284 25.6789C23.1714 25.8055 23.0272 25.7865 22.9372 25.6743C22.2567 24.4753 20.4146 24.9583 20.4146 26.3388C20.4146 28.2179 22.3898 29.3349 22.9952 29.6324C23.0692 29.6691 23.1558 29.6691 23.2294 29.6324C23.8352 29.3337 25.8108 28.2134 25.8108 26.3388C25.8104 24.9644 23.974 24.4692 23.284 25.6789Z'
        fill='#FF5155'
      />
      <path
        d='M23.1939 25.8235C23.1939 25.7971 23.1958 25.772 23.197 25.746C23.1043 25.7903 23.0055 25.759 22.9372 25.6743C22.2567 24.4753 20.4146 24.9583 20.4146 26.3388C20.4146 28.2179 22.3898 29.3349 22.9952 29.6324C23.0692 29.6691 23.1558 29.6691 23.2294 29.6324C23.5422 29.4783 24.2189 29.1049 24.8015 28.5224C24.045 27.962 23.1939 27.0568 23.1939 25.8235Z'
        fill='#F24049'
      />
      <path
        d='M31.4264 25.4236H28.4449C28.0279 25.4236 27.6899 25.086 27.6899 24.6691C27.6899 24.2522 28.0279 23.9146 28.4449 23.9146H31.4264C31.843 23.9146 32.181 24.2522 32.181 24.6691C32.181 25.086 31.843 25.4236 31.4264 25.4236Z'
        fill='#4188FF'
      />
      <path
        d='M31.4264 28.0806H28.4449C28.0279 28.0806 27.6899 27.7426 27.6899 27.3261C27.6899 26.9091 28.0279 26.5715 28.4449 26.5715H31.4264C31.843 26.5715 32.181 26.9091 32.181 27.3261C32.181 27.7426 31.843 28.0806 31.4264 28.0806Z'
        fill='#4188FF'
      />
      <path
        d='M31.4264 30.7376H28.4449C28.0279 30.7376 27.6899 30.3996 27.6899 29.9831C27.6899 29.5661 28.0279 29.2285 28.4449 29.2285H31.4264C31.843 29.2285 32.181 29.5661 32.181 29.9831C32.181 30.3996 31.843 30.7376 31.4264 30.7376Z'
        fill='#4188FF'
      />
      <path
        d='M60.4581 30.894L61.0589 30.0365C61.493 29.4162 61.3408 28.5541 60.7209 28.12L43.4152 16.0022C42.7949 15.5681 41.9324 15.7199 41.4983 16.3402L40.8978 17.1977C40.4637 17.8176 40.6159 18.6801 41.2358 19.1142L58.5416 31.232C59.1618 31.6661 60.0243 31.5139 60.4581 30.894Z'
        fill='#DDE4F7'
      />
      <path
        d='M44.653 19.1142C44.0331 18.6801 43.8809 17.8176 44.315 17.1977L44.5809 16.8182L43.4155 16.0022C42.7952 15.5681 41.9331 15.7199 41.499 16.3402L40.8982 17.1977C40.4644 17.8176 40.6163 18.6801 41.2361 19.1142L58.5419 31.232C59.1622 31.6661 60.0247 31.5139 60.4588 30.894L60.7933 30.416L44.653 19.1142Z'
        fill='#CCD7F2'
      />
      <path
        d='M25.8165 38.7813C25.8165 41.2086 23.8485 43.1766 21.4212 43.1766C18.9939 43.1766 17.0259 41.2086 17.0259 38.7813C17.0259 36.3536 18.9939 34.386 21.4212 34.386C23.8485 34.386 25.8165 36.3536 25.8165 38.7813Z'
        fill='#FFCDBE'
      />
      <path
        d='M20.4057 38.7812C20.4057 36.9524 21.5226 35.3853 23.1111 34.7227C22.5908 34.506 22.0201 34.3855 21.4212 34.3855C18.9939 34.3855 17.0259 36.3535 17.0259 38.7808C17.0259 41.2085 18.9939 43.1761 21.4212 43.1761C22.0201 43.1761 22.5908 43.0559 23.1111 42.8389C21.5226 42.177 20.4057 40.6096 20.4057 38.7812Z'
        fill='#F7C1B3'
      />
      <path
        d='M31.1182 42.5039C31.1182 42.4734 31.1209 42.4436 31.1236 42.4142L28.137 41.7592C27.2314 41.5388 26.317 42.0938 26.0958 43.0002C25.8749 43.9062 26.4303 44.8202 27.3367 45.041L31.1182 45.8898C31.1182 43.9611 31.1182 42.6076 31.1182 42.5039Z'
        fill='#FFCDBE'
      />
      <path
        d='M29.1567 43.3675C29.2792 42.8655 29.5679 42.4474 29.9494 42.1567L28.137 41.7592C27.2311 41.5388 26.3167 42.0938 26.0958 43.0002C25.8749 43.9062 26.4303 44.8202 27.3367 45.041L29.9868 45.6361C29.2979 45.1333 28.9423 44.2476 29.1567 43.3675Z'
        fill='#F7C1B3'
      />
      <path
        d='M58.1158 43.6147H52.8149V46.9927H58.1158C59.0485 46.9927 59.805 46.2366 59.805 45.3035C59.805 44.3708 59.0485 43.6147 58.1158 43.6147Z'
        fill='#FFCDBE'
      />
      <path
        d='M55.8621 43.6147H52.8149V46.9927H55.8621C55.8621 45.5194 55.8621 44.3243 55.8621 43.6147Z'
        fill='#F7C1B3'
      />
      <path
        d='M52.1413 42.4392H35.7576C35.6798 42.4392 35.6019 42.4296 35.5264 42.4113L32.0222 41.5568C31.4084 41.4069 30.8164 41.8719 30.8164 42.504V60.8337C30.8164 61.3719 31.2528 61.8083 31.7914 61.8083H52.1413C52.68 61.8083 53.1164 61.3719 53.1164 60.8337C53.1164 60.63 53.1164 43.8789 53.1164 43.4142C53.1164 42.8756 52.68 42.4392 52.1413 42.4392Z'
        fill='#63A1FC'
      />
      <path
        d='M34.3507 60.8337C34.3507 60.535 34.3507 42.8901 34.3507 42.504C34.3507 42.3747 34.3767 42.253 34.4213 42.1416L32.0222 41.5568C31.4084 41.4069 30.8164 41.8719 30.8164 42.504V60.8337C30.8164 61.3719 31.2528 61.8083 31.7914 61.8083H35.3261C34.7875 61.8083 34.3507 61.3719 34.3507 60.8337Z'
        fill='#4188FF'
      />
    </g>
    <defs>
      <clipPath id='clip0_414_10863'>
        <rect width='50' height='50' fill='white' transform='translate(15 15)' />
      </clipPath>
    </defs>
  </svg>
));
GeneralSurgeryIcon.displayName = 'GeneralSurgeryIcon';

export default GeneralSurgeryIcon;
